'use client';

import React from 'react';

const SubjectsSection: React.FC = () => {
  const subjects = [
    {
      icon: '📚',
      title: 'English, LA & Social Studies K–12',
      desc: 'Reading comprehension, essay writing, literary analysis, and social studies support for all grades.',
    },
    {
      icon: '📐',
      title: 'Math & Science K–12',
      desc: 'From basic arithmetic to calculus and physics — we make complex concepts click at every grade level.',
    },
    {
      icon: '🎓',
      title: 'College & University Level',
      desc: 'University coursework, research writing, and subject-specific deep dives for post-secondary students.',
    },
    {
      icon: '🌱',
      title: 'Adult Learning',
      desc: 'Upgrading, retraining, or returning to education — we support adult learners at every stage.',
    },
    {
      icon: '💻',
      title: 'Computer Skills',
      desc: 'Coding fundamentals, learning to use a computer, navigating the internet, spreadsheets, word processing, and essential digital literacy for all ages.',
    },
    {
      icon: '🌍',
      title: 'Second Languages',
      desc: 'French, Spanish, Mandarin, and more — build conversational skills, grammar, and vocabulary in a new language.',
    },
    {
      icon: '🇫🇷',
      title: 'French Immersion',
      desc: 'Specialized support for French Immersion students — from early immersion to advanced coursework in all core subjects taught in French.',
    },
  ];

  return (
    <section
      style={{
        padding: '5rem 1.25rem',
        maxWidth: 1200,
        margin: '0 auto',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <div className="section-label">What We Offer</div>
      <h2
        className="section-title"
        style={{ fontFamily: "'Playfair Display', serif" }}
      >
        Every Subject.
        <br />
        Every Level.
      </h2>
      <div className="gold-line" />

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '1.5rem',
        }}
      >
        {subjects.map((subject) => (
          <div key={subject.title} className="subject-card mobile-subject-card">
            <div style={{ fontSize: '2.2rem', marginBottom: '1rem' }}>{subject.icon}</div>
            <h3
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: '1.2rem',
                marginBottom: '0.5rem',
                color: '#ffffff',
              }}
            >
              {subject.title}
            </h3>
            <p style={{ fontSize: '0.9rem', color: 'rgba(255,255,255,0.55)', lineHeight: 1.6 }}>
              {subject.desc}
            </p>
          </div>
        ))}
      </div>
      <style>{`
        @media (max-width: 500px) {
          .mobile-subject-card {
            padding: 1.25rem !important;
          }
        }
      `}</style>
    </section>
  );
};

export default SubjectsSection;
